import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = `
Política de Privacidad

Última actualización: Marzo 2026

1. Información que Recopilamos
Recopilamos únicamente la información necesaria para procesar tu compra y entregarte el producto digital, incluyendo tu nombre, dirección de correo electrónico y datos de pago.

2. Uso de la Información
Tu información personal se utiliza exclusivamente para:
• Procesar y completar tu compra.
• Enviarte el acceso al producto digital adquirido.
• Comunicarnos contigo sobre tu pedido o actualizaciones del producto.

3. Protección de Datos
Implementamos medidas de seguridad técnicas y organizativas para proteger tu información personal contra acceso no autorizado, alteración o destrucción.

4. Compartir Información
No vendemos, intercambiamos ni transferimos tu información personal a terceros. La única excepción son los proveedores de servicios de pago necesarios para procesar tu transacción.

5. Cookies
Nuestro sitio puede utilizar cookies para mejorar tu experiencia de navegación. Puedes configurar tu navegador para rechazar cookies, aunque esto podría afectar algunas funcionalidades.

6. Tus Derechos
Tienes derecho a acceder, rectificar o eliminar tu información personal en cualquier momento. Para ejercer estos derechos, contáctanos a través de los canales proporcionados.

7. Cambios en esta Política
Nos reservamos el derecho de actualizar esta política en cualquier momento. Los cambios serán publicados en esta página con la fecha de actualización correspondiente.
`.trim();
const termsContent = `
Términos y Condiciones

Última actualización: Marzo 2026

1. Aceptación de los Términos
Al realizar la compra del Protocolo Dopamina Limpia, aceptas estos términos y condiciones en su totalidad. Si no estás de acuerdo, no realices la compra.

2. Producto Digital
El Protocolo Dopamina Limpia es un producto digital educativo e informativo. Recibirás acceso inmediato tras completar la compra. El contenido incluye un ebook, audio-guías, checklists y hojas de trabajo en formato digital.

3. Uso Personal
El producto es para uso personal y no comercial. Queda prohibida la reproducción, distribución o reventa del contenido sin autorización expresa.

4. Descargo de Responsabilidad
Este producto tiene fines educativos e informativos únicamente. No sustituye el consejo médico profesional. Si tienes condiciones de salud mental preexistentes, consulta con un profesional antes de seguir el protocolo.

5. Política de Reembolso
Debido a la naturaleza digital del producto y el acceso inmediato, no ofrecemos reembolsos una vez completada la descarga. Si experimentas problemas técnicos, contáctanos para resolverlos.

6. Propiedad Intelectual
Todo el contenido del Protocolo Dopamina Limpia está protegido por derechos de autor. Queda prohibida cualquier reproducción no autorizada.

7. Limitación de Responsabilidad
No garantizamos resultados específicos. Los resultados pueden variar según el individuo y su compromiso con el protocolo. No nos hacemos responsables de daños directos o indirectos derivados del uso del producto.

8. Modificaciones
Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor desde su publicación en esta página.
`.trim();
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="w-full bg-dark border-t border-white/10 px-4 py-8" data-id="element-49">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-50">
          <p className="font-inter text-sm text-text/40" data-id="element-51">
            © 2026 Protocolo Dopamina Limpia. Todos los derechos reservados.
          </p>

          <div className="flex items-center gap-6" data-id="element-52">
            <button onClick={() => setActiveModal('privacy')} className="font-inter text-sm text-text/50 hover:text-teal transition-colors" data-id="element-53">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="font-inter text-sm text-text/50 hover:text-teal transition-colors" data-id="element-54">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-55">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={closeModal} data-id="element-56">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-dark-lighter border border-white/10 rounded-xl w-full max-w-2xl max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-57">
              <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-58">
                <h3 className="font-bebas text-2xl md:text-3xl text-white" data-id="element-59">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={closeModal} className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-white/10 transition-colors" aria-label="Cerrar" data-id="element-60">
                  <XIcon className="w-5 h-5 text-text/60" data-id="element-61" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-62">
                <div className="font-inter text-sm text-text/70 leading-relaxed whitespace-pre-line" data-id="element-63">
                  {activeModal === 'privacy' ? privacyContent : termsContent}
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}